import { forwardRef } from "react";

export const CustomInput = forwardRef(
  ({ value, onClick, className, id, name, label, readOnly, placeholder }, ref) => (
    <label htmlFor={id} className="relative block w-full">    
      <input 
        dir='rtl' 
        readOnly={readOnly} 
        required 
        className={className} 
        name={name} 
        id={id} 
        value={value} 
        onClick={onClick} 
        ref={ref} 
        placeholder={placeholder} 
      />
      {/* 🌟 Floating Label Classes Restored */}
      <span className="pointer-events-none font-bold text-text-secondary px-1"> 
        {label} 
      </span>
    </label>
  ),
);

export const selectStyles = {
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--text-primary)',
  }),
  input: (provided) => ({
    ...provided,
    color: 'var(--text-primary)',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'var(--text-secondary)', 
  }),
  control: (provided, state) => ({
    ...provided,
    maxHeight: '100px',
    overflow: 'auto',
    minWidth: '100px', 
    minHeight: '50px',
    backgroundColor: 'var(--bg-tertiary)',
    borderRadius: '0.75rem',
    padding: '0 4px',
    borderColor: state.isFocused ? 'var(--brand-primary)' : 'var(--border-color)',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--brand-primary)' : 'var(--border-color)',
    }
  }),
  menuPortal: (base) => ({ 
    ...base, 
    zIndex: 9999,  
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'var(--bg-secondary)',
    border: '1px solid var(--border-color)',
    borderRadius: '12px',
    padding: '5px',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px', 
    backgroundColor: 'var(--bg-secondary)',
    '@media (min-width: 768px)': { maxHeight: '140px' },
    '@media (min-width: 1024px)': { maxHeight: '140px' },
    '&::-webkit-scrollbar': { width: '6px' },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--border-color)',
      borderRadius: '4px',
    },
  }),
  multiValue: (base, state) => ({
    ...base,
    fontSize: "14px",
    backgroundColor: state.data.isFixed ? 'var(--bg-primary)' : 'var(--bg-secondary)',
    borderRadius: 6
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontWeight: 'bold',
    color: 'var(--text-primary)',
  }),
  multiValueRemove: (base, state) => (
    state.data.isFixed 
      ? { ...base, display: 'none' } 
      : { 
          ...base, 
          color: 'var(--text-secondary)',  
          borderRadius: 6, 
          ':hover': { color: 'var(--bg-primary)', backgroundColor: 'var(--danger)' } 
        }
  ),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? 'var(--brand-primary)' 
      : state.isFocused ? 'var(--bg-tertiary)' : 'transparent',
    color: state.isSelected ? 'var(--brand-light)' : 'var(--text-primary)',
    cursor: 'pointer',
    fontSize: '12px',
    borderRadius: '8px',
    margin: '2px 0',
    '@media (min-width: 768px)': { fontSize: '14px' },
    overflowWrap: 'anywhere',
    '&:active': { backgroundColor: 'var(--brand-hover)' },
  }),
};

